import React, {useState, useEffect} from 'react';
import { NumericFormat } from 'react-number-format';
import { format, differenceInDays } from 'date-fns';
import { it } from 'date-fns/locale';
import schedulePayService from '../../services/SchedulePayService';

const formatCurrency = (value) => {
    return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
    }).format(value);
};

export default function LayerCreditInfo({itemsPerPage = 15,show,onClose,schedulePay}) {
    const [resultCredits, setResultCredits] = useState([]);
    const [loading, setLoading] = useState(true);
    const [itemsPerPageLocal, setItemsPerPageLocal] = useState(itemsPerPage);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalResults, setTotalResults] = useState(0);

    const totalPages = Math.ceil(resultCredits.length / itemsPerPageLocal);
    // Calcola gli elementi da mostrare nella pagina corrente
    const startIndex = (currentPage - 1) * itemsPerPageLocal;
    const endIndex = startIndex + itemsPerPageLocal;
    const currentItems = resultCredits.slice(startIndex, endIndex);
    // Funzione di navigazione
    const goToPage = (page) => {
        setCurrentPage(page);
    };

    const closeSlide = () => {
        onClose();
    };

    const fetchPays= async (data) => {
        try {
            const res = await schedulePayService.getCreditNote(data.id_schedule_pay);

            // Estrarre i dati specifici dalla struttura complessa di response.data
            const resultsData = res.data || [];
            const total = res.data.length || 0;

            setResultCredits(resultsData); // Salva i risultati
            setTotalResults(total); // Salva il totale dei risultati
            //setCurrentPage(1); // da valutare ogni modifica torna alla prima pagina
            setLoading(false);
            // Calcoliamo dinamicamente itemsPerPageLocal dopo aver ricevuto i dati
            const defaultItemsPerPage = Math.min(itemsPerPage, total);
            setItemsPerPageLocal(defaultItemsPerPage);

        } catch (error) {
            console.error('Error fetching clients', error);
        }
    };

    useEffect(() => {
        fetchPays(schedulePay);
    }, [schedulePay]);

  	return (
  	    <>
  	    <div className={`offcanvas offcanvas-end ${show ? "show" : ""}`}>
            <div className="offcanvas-header border-bottom">
                <h5 className="offcanvas-title">Nota di Credito</h5>
                <button onClick={closeSlide} className="btn-close text-reset"></button>
            </div>
            <div className="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
            {loading && !resultCredits ? (
                <p>Caricamento in corso...</p>
            ) : (
                <div className="card">
                    <div className="card-datatable table-responsive">
                        <div className="dataTables_wrapper dt-bootstrap5 no-footer">
                            <table className="datatables-users table border-top dataTable no-footer dtr-column">
                                <thead>
                                    <tr>
                                        <th>NR</th>
                                        <th>CLIENTE</th>
                                        <th>PAGAMENTO</th>
                                        <th>DATA</th>
                                        <th>ESITO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.map((result,index) => (
                                    <React.Fragment key={result.id_schedule_pay}>
                                        <tr>
                                            <td>{result.invoice}</td>
                                            <td>{result.fullName}</td>
                                            <td>{formatCurrency(result.amount)}</td>
                                            <td>{result.invoiceDate ? format(new Date(result.invoiceDate), 'dd MMMM yyyy', { locale: it }) : ''}</td>
                                            <td>{result.status}</td>
                                        </tr>
                                    </React.Fragment>
                                    ))}
                                 </tbody>
                            </table>
                            <div className="row">
                                <div className="col-sm-12 col-md-6">
                                    <div className="dataTables_info" role="status" aria-live="polite">
                                        Risultati ottenuti : {totalResults}
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-6">
                                    <div className="dataTables_paginate paging_simple_numbers custom-ryo">
                                        {!loading && (
                                            <div className="pagination">
                                                <button className="page-link" onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}>
                                                    <i className="bx bx-chevron-left bx-18px"></i>
                                                </button>
                                                {Array.from({ length: totalPages }, (_, index) => (
                                                    <button
                                                      key={index + 1}
                                                      onClick={() => goToPage(index + 1)}
                                                      disabled={currentPage === index + 1}
                                                      className={`page-link ${currentPage === index + 1  ? "current-page" : ""}`}
                                                    >
                                                      {index + 1}
                                                    </button>
                                                ))}
                                                <button className="page-link" onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}>
                                                    <i className="bx bx-chevron-right bx-18px"></i>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            </div>
  	    </div>
  	    </>
	);
}